<template>
  <div class="flex max-w-7xl mx-auto px-4 md:pt-12 pt-0 md:pb-8">
    <article class="theme-page-content flex-1">
      <div class="flex items-center">
        <h1 class="pb-2 mb-0">{{ courseDisplayHeading }}</h1>
        <RevisionSelector
          v-if="course.courseGroupId"
          class="ml-2 pb-5 self-center"
          entity-type="courses"
          :entity-id="course.courseGroupId" 
        />
        <div class="flex-grow"></div>
        <span v-if="enablePrintDocuments && course.id" class="link text-underline flex items-center" @click="() => downloadDocument(course.id)">
          <BaseIcon
            v-if="isDownloadingDocument"
            icon="spinner"
            class="spinner inline-block mr-2"
          />
          <h2>Download as PDF</h2>
        </span>
      </div>
      <PageTemplateRenderer
        :content="course"
        type="course"
      />
    </article>
    <slot name="sidebar" />
  </div>
</template>

<script>
import PageTemplateRenderer from '@/components/PageTemplateRenderer'
import useInterpolation from '@/composables/useInterpolation'
import useDocumentsDownload from '@/composables/useDocumentsDownload'
import { generateCourseLabel } from '@/utils/dataLabels'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { TITLE_INTERPOLATIONS, PRINT_DOCUMENTS } from '@/constants/featureFlags'
import RevisionSelector from '@/components/RevisionSelector'

export default {
  components: {
    PageTemplateRenderer,
    RevisionSelector
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { enableTitleInterpolations, enablePrintDocuments } = useFeatureFlags(
      {
        enableTitleInterpolations: TITLE_INTERPOLATIONS,
        enablePrintDocuments: PRINT_DOCUMENTS,
      }
    )
    const { getInterpolatedFieldValue } = useInterpolation()
    const { downloadDocument, isDownloadingDocument } = useDocumentsDownload()
    return {
      getInterpolatedFieldValue,
      enableTitleInterpolations,
      enablePrintDocuments,
      downloadDocument,
      isDownloadingDocument,
    }
  },
  computed: {
    courseDisplayHeading() {
      return generateCourseLabel(this.course, undefined, {
        getInterpolatedFieldValue: this.enableTitleInterpolations
          ? this.getInterpolatedFieldValue
          : undefined,
        nameOnlyFallback: true,
      })
    },
  },
}
</script>
